'use client';

import { useRouter } from 'next/navigation';
import { FaChevronRight } from 'react-icons/fa6';

type NavbarProps = {
  showBack?: boolean;
  backHref?: string;
};

export default function Navbar({ showBack = false, backHref = '/' }: NavbarProps) {
  const router = useRouter();

  return (
    <nav className="w-full">
      <div className="mx-auto max-w-xl bg-c1 p-3 text-white shadow-lg rounded-b-lg">

        {/* ساختار Grid برای تراز کردن دقیق */}
        <div className="grid grid-cols-[40px_1fr_40px] items-center">

          {/* ستون 1: دکمه (راست) */}
          <div className="flex justify-end">
            {showBack && (
              <button
                type="button"
                onClick={() => (window.history.length > 1 ? router.back() : router.push(backHref))}
                className="transition-transform hover:scale-105 active:scale-95 text-sm font-medium"
                aria-label="بازگشت"
              >
                <FaChevronRight size={24}  className="text-white/90" />
              </button>
            )}
          </div>

          {/* ستون ۲: متن (وسط) */}
          <div className="text-center">
            <div className="text-sm font-bold">قصه شب برای همه کودکان این سرزمین</div>
            <div className="text-xs opacity-80 mt-0.5">
              (بنیاد نظریانی |{' '}
              <a href="https://nazariani.org" target="_blank" rel="noopener noreferrer" >
                Nazariani.org
              </a>
              )
            </div>
          </div>

          {/* ستون 3: فضای خالی (برای متعادل کردن فاصله) */}

          <div></div>


        </div>
      </div>
    </nav>
  );
}
